module.exports = __webpack_public_path__ + "img/设备租赁行业.046d7f09.png";